/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParcDto } from './ParcDto';
import {
    ParcDtoFromJSON,
    ParcDtoFromJSONTyped,
    ParcDtoToJSON,
    ParcDtoToJSONTyped,
} from './ParcDto';
import type { RealEstateDto } from './RealEstateDto';
import {
    RealEstateDtoFromJSON,
    RealEstateDtoFromJSONTyped,
    RealEstateDtoToJSON,
    RealEstateDtoToJSONTyped,
} from './RealEstateDto';
import type { TenantDto } from './TenantDto';
import {
    TenantDtoFromJSON,
    TenantDtoFromJSONTyped,
    TenantDtoToJSON,
    TenantDtoToJSONTyped,
} from './TenantDto';
import type { QuestionAnswerDto } from './QuestionAnswerDto';
import {
    QuestionAnswerDtoFromJSON,
    QuestionAnswerDtoFromJSONTyped,
    QuestionAnswerDtoToJSON,
    QuestionAnswerDtoToJSONTyped,
} from './QuestionAnswerDto';

/**
 * 
 * @export
 * @interface GetRealEstateWithTenantsResponse
 */
export interface GetRealEstateWithTenantsResponse {
    /**
     * 
     * @type {Array<TenantDto>}
     * @memberof GetRealEstateWithTenantsResponse
     */
    tenants: Array<TenantDto>;
    /**
     * Details of the real estate property. Null when the contract covers a park (realEstatePark set).
     * @type {RealEstateDto}
     * @memberof GetRealEstateWithTenantsResponse
     */
    realEstate?: RealEstateDto | null;
    /**
     * List of questionnaire responses associated with the property
     * @type {Array<QuestionAnswerDto>}
     * @memberof GetRealEstateWithTenantsResponse
     */
    surveyAnswers?: Array<QuestionAnswerDto> | null;
    /**
     * Park covered by the contract (park-based risk). Null for single-property contracts.
     * @type {ParcDto}
     * @memberof GetRealEstateWithTenantsResponse
     */
    realEstatePark?: ParcDto | null;
    /**
     * Ids of the park properties actually covered by the contract (included in the coverage config with at least one active garantie). Null for single-property contracts.
     * 
     * @type {Array<string>}
     * @memberof GetRealEstateWithTenantsResponse
     */
    coveredRealEstateIds?: Array<string> | null;
}

/**
 * Check if a given object implements the GetRealEstateWithTenantsResponse interface.
 */
export function instanceOfGetRealEstateWithTenantsResponse(value: object): value is GetRealEstateWithTenantsResponse {
    if (!('tenants' in value) || value['tenants'] === undefined) return false;
    return true;
}

export function GetRealEstateWithTenantsResponseFromJSON(json: any): GetRealEstateWithTenantsResponse {
    return GetRealEstateWithTenantsResponseFromJSONTyped(json, false);
}

export function GetRealEstateWithTenantsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRealEstateWithTenantsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tenants': ((json['tenants'] as Array<any>).map(TenantDtoFromJSON)),
        'realEstate': json['realEstate'] == null ? undefined : RealEstateDtoFromJSON(json['realEstate']),
        'surveyAnswers': json['surveyAnswers'] == null ? undefined : ((json['surveyAnswers'] as Array<any>).map(QuestionAnswerDtoFromJSON)),
        'realEstatePark': json['realEstatePark'] == null ? undefined : ParcDtoFromJSON(json['realEstatePark']),
        'coveredRealEstateIds': json['coveredRealEstateIds'] == null ? undefined : json['coveredRealEstateIds'],
    };
}

export function GetRealEstateWithTenantsResponseToJSON(json: any): GetRealEstateWithTenantsResponse {
    return GetRealEstateWithTenantsResponseToJSONTyped(json, false);
}

export function GetRealEstateWithTenantsResponseToJSONTyped(value?: GetRealEstateWithTenantsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenants': ((value['tenants'] as Array<any>).map(TenantDtoToJSON)),
        'realEstate': RealEstateDtoToJSON(value['realEstate']),
        'surveyAnswers': value['surveyAnswers'] == null ? undefined : ((value['surveyAnswers'] as Array<any>).map(QuestionAnswerDtoToJSON)),
        'realEstatePark': ParcDtoToJSON(value['realEstatePark']),
        'coveredRealEstateIds': value['coveredRealEstateIds'],
    };
}

